import { ActionsBase, CaseModel, SelectedApexMech, State as StateBase, StateDescription as StateDescriptionBase, StateTransitionData } from "@ortho-next/nextray-core";
import { FitboneMesh, LayerElements } from "../Models/AppModel";
import { Context } from "./Context";

/**
 * List of context events.
 */
export interface Actions extends ActionsBase<LayerElements> {  // TODO fix bridgeresult?
	/**
	 * Sets the initial state based on the case model.
	 */
	setInitialState: CaseModel;
	/**
	 * Set insert selected apex during ostoetomy workflow.
	 */
	selectApex: SelectedApexMech;
	/**
	 * Ends insert osteotomy workflow.
	 */
	confirmApex: null;
	/**
	 * Adds or removes the plane cut along the osteotomy.
	 */
	cutEoC: boolean;
	/**
	 * Starts select osteotomy workflow.
	 */
	startSelectingApex: null;
	/**
	 * Ends select apex workflow and restore old selected apex value.
	 */
	cancelSelectingApex: null;
	/**
	 * Starts insertion point workflow.
	 */
	startInsertionPoint: null;
	/**
	 * Cancel insertion point workflow.
	 */
	cancelInsertionPoint: null;
	/**
	 * Confirm insertion point workflow.
	 */
	confirmInsertionPoint: null;
	/**
	 * Rotate camera based on current state.
	 */
	rotateCamera: null;
	/**
	 * Starts the inserting fitbone workflow.
	 */
	startInsertingFitbone: null;
	/**
	 * Ends inserting fitbone workflow.
	 */
	confirmFitbone: null;
	/**
	 * Ends inserting fitbone workflow and restore old selected fitbone.
	 */
	cancelFitbone: null;
	/**
	 * Inserts fitbone to the scenes.
	 */
	insertFitbone: FitboneMesh;
	/**
	 * Lock/Unlock stroke movement.
	 */
	lockStroke: boolean;
	/**
	 * Updates measures available for print report only.
	 */
	updateMeausuresOnlyPrint: null;
	/**
	 * Generates images for print report.
	 */
	generateImagesToPrint: { w: number, h: number };
	/**
	* Start the crop polygon tool
	*/
	startCropPolygon: null;
	/**
	* Confirm and close the crop polygon tool
	*/
	confirmCropPolygon: null;
	/**
	* Open viewer.
	*/
	openViewer: null;
	/**
	* Close viewer.
	*/
	closeViewer: null;
	/**
	* Set viewer.
	*/
	setViewer: ViewerStateTypes;
	/**
	* Add a Blocking Screw in the active view.
	*/
	addBlockingScrew: null;
	/**
	* Delete the selected Blocking Screw in the active view.
	*/
	deleteBlockingScrew: null;
	/**
	* Delete the selected Measurement Tool in the active view.
	*/
	deleteMeasurementTool: null;
	/**
	 * Set realistic zoom in the active view.
	 */
	setRealisticZoom: number;
}

export enum OsteotomyCut {
	none,
	opening,
	closing
}

export enum PrintStateTypes {
	none,
	deformityAnalysis,
	openFitboneLock,
	closeFitboneLock,
}

export enum ViewerStateTypes {
	none,
	fitToView,
	proximal,
	distal,
	osteotomy
}

/**
 * Workflow list.
 */
export enum WorkflowRunning {
	none,
	insertOsteotomy,
	insertInsertionPoint,
	insertFitbone
}

/**
 * Data of current state.
 */
export interface StateDescription extends StateDescriptionBase {
	isWorkflowRunning: WorkflowRunning; //override
}

/**
 * Abstract class to create a state.
 */
export abstract class State extends StateBase<Actions> {
	public abstract override stateDescription: StateDescription; //todo StateDescription override
	protected abstract override handleChangeStateEvent<K extends keyof Actions>(event: K, args: Actions[K]): StateTransitionData;
	protected declare _context: Context;
	protected declare _caseModel: CaseModel;
	protected declare _restore: object;

	public override onAfterInit(): void {
		super.onAfterInit();
		this.handle("rotateCamera", null);
	}

	protected override handleNotChangeStateEvent<K extends keyof Actions>(event: K, args: Actions[K]): StateTransitionData {
		switch (event) {
			case "rotateCamera":
				this.dispatchToMain(event, args);
				return { type: this.type };
		}
		return super.handleNotChangeStateEvent(event, args);
	}
}
